import { IMedicationCoSoItemRequest } from '../../../models/request/y-te/yTeRequests';
import { medication, MedicationCoSoItemResponse } from '../../../models/response/y-te/medication';

export enum eMedicationActionTypeIds {
	LOAD_START = "MEDICATION_LOAD_START",
	LOAD_SUCCESS = "MEDICATION_LOAD_SUCCESS",
	LOAD_ERROR = "MEDICATION_LOAD_ERROR",

	LOAD_DETAIL_START = "MEDICATION_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "MEDICATION_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "MEDICATION_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "MEDICATION_SHOW_DETAIL",
	CLOSE_DETAIL = "MEDICATION_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "MEDICATION_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "MEDICATION_SHOW_CONFIRM",
	CLOSE_CONFIRM = "MEDICATION_CLOSE_CONFIRM",

	SAVE_START = "MEDICATION_SAVE_START",
	SAVE_SUCCESS = "MEDICATION_SAVE_SUCCESS",
	SAVE_ERROR = "MEDICATION_SAVE_ERROR",

	DELETE_START = "MEDICATION_DELETE_START",
	DELETE_SUCCESS = "MEDICATION_DELETE_SUCCESS",
	DELETE_ERROR = "MEDICATION_DELETE_ERROR",

	SHOW_DANGKY_MODAL = "MEDICATION_SHOW_DANGKY_MODAL",
	CLOSE_DANGKY_MODAL = "MEDICATION_CLOSE_DANGKY_MODAL",

	LOAD_DANGKY_START = "MEDICATION_LOAD_DANGKY_START",
	LOAD_DANGKY_SUCCESS = "MEDICATION_LOAD_DANGKY_SUCCESS",
	LOAD_DANGKY_ERROR = "MEDICATION_LOAD_DANGKY_ERROR",

	CHANGE_DANGKY_DATAS = "MEDICATION_CHANGE_DANGKY_DATAS",

	SAVE_DANGKY_START = "MEDICATION_SAVE_DANGKY_START",
	SAVE_DANGKY_SUCCESS = "MEDICATION_SAVE_DANGKY_SUCCESS",
	SAVE_DANGKY_ERROR = "MEDICATION_SAVE_DANGKY_ERROR"
}

export interface IMedicationLoadStart {
	type: eMedicationActionTypeIds.LOAD_START,
	payload: number
}
export interface IMedicationLoadSuccess {
	type: eMedicationActionTypeIds.LOAD_SUCCESS,
	payload: MedicationCoSoItemResponse[]
}
export interface IMedicationLoadErr {
	type: eMedicationActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IMedicationLoadDetailStart {
	type: eMedicationActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IMedicationLoadDetailSuccess {
	type: eMedicationActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: medication
}
export interface IMedicationLoadDetailErr {
	type: eMedicationActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IMedicationShowDetail {
	type: eMedicationActionTypeIds.SHOW_DETAIL,
	payload?: medication
}
export interface IMedicationCloseDetail {
	type: eMedicationActionTypeIds.CLOSE_DETAIL
}
export interface IMedicationChangeSelectedIds {
	type: eMedicationActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IMedicationShowConfirm {
	type: eMedicationActionTypeIds.SHOW_CONFIRM
}
export interface IMedicationCloseConfirm {
	type: eMedicationActionTypeIds.CLOSE_CONFIRM
}
export interface IMedicationSaveStart {
	type: eMedicationActionTypeIds.SAVE_START,
	payload: medication
}
export interface IMedicationSaveSuccess {
	type: eMedicationActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IMedicationSaveErr {
	type: eMedicationActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IMedicationDeleteStart {
	type: eMedicationActionTypeIds.DELETE_START,
	payload: number
}
export interface IMedicationDeleteSuccess {
	type: eMedicationActionTypeIds.DELETE_SUCCESS
}
export interface IMedicationDeleteErr {
	type: eMedicationActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IMedicationShowDangKyModal {
	type: eMedicationActionTypeIds.SHOW_DANGKY_MODAL
}
export interface IMedicationCloseDangKyModal {
	type: eMedicationActionTypeIds.CLOSE_DANGKY_MODAL
}
export interface IMedicationLoadDangKyStart {
	type: eMedicationActionTypeIds.LOAD_DANGKY_START,
	payload: number
}
export interface IMedicationLoadDangKySuccess {
	type: eMedicationActionTypeIds.LOAD_DANGKY_SUCCESS,
	payload: MedicationCoSoItemResponse[]
}
export interface IMedicationLoadDangKyErr {
	type: eMedicationActionTypeIds.LOAD_DANGKY_ERROR,
	payload: string
}
export interface IMedicationChangeDangKyDatas {
	type: eMedicationActionTypeIds.CHANGE_DANGKY_DATAS,
	payload: MedicationCoSoItemResponse[]
}
export interface IMedicationSaveDangKyStart {
	type: eMedicationActionTypeIds.SAVE_DANGKY_START,
	payload: IMedicationCoSoItemRequest
}
export interface IMedicationSaveDangKySuccess {
	type: eMedicationActionTypeIds.SAVE_DANGKY_SUCCESS
}
export interface IMedicationSaveDangKyErr {
	type: eMedicationActionTypeIds.SAVE_DANGKY_ERROR,
	payload: string
}

export type IMedicationActionTypes = IMedicationLoadStart | IMedicationLoadSuccess | IMedicationLoadErr |
	IMedicationLoadDetailStart | IMedicationLoadDetailSuccess | IMedicationLoadDetailErr |
	IMedicationShowDetail | IMedicationCloseDetail |
	IMedicationChangeSelectedIds |
	IMedicationShowConfirm | IMedicationCloseConfirm |
	IMedicationSaveStart | IMedicationSaveSuccess | IMedicationSaveErr |
	IMedicationDeleteStart | IMedicationDeleteSuccess | IMedicationDeleteErr |
	IMedicationShowDangKyModal | IMedicationCloseDangKyModal |
	IMedicationLoadDangKyStart | IMedicationLoadDangKySuccess | IMedicationLoadDangKyErr |
	IMedicationChangeDangKyDatas |
	IMedicationSaveDangKyStart | IMedicationSaveDangKySuccess | IMedicationSaveDangKyErr
